tablet 		= 600;
ipad 		= 760;
desktop 	= 1000;
large 		= 1200;
xlarge 		= 1400;

/* Heights */
short 		= 450;
medium 		= 600;
tall 		= 750;
xtall 		= 800;